import compass from '~/assets/icons/compass.svg';
import house from '~/assets/icons/home.svg';
import car from '~/assets/icons/car.svg';
import shirt from '~/assets/icons/tshirt.svg';
import box from '~/assets/icons/box_3.svg';

export enum AppAdsTypes {
	Realty = 'realty',
	Vehicle = 'vehicle',
	Clothes = 'clothes',
	Other = 'other',
}

export enum AppAdsFilter {
	Main = 'main',
	Realty = AppAdsTypes.Realty,
	Vehicle = AppAdsTypes.Vehicle,
	Clothes = AppAdsTypes.Clothes,
	Other = AppAdsTypes.Other,
}

export enum AppAdsPages {
	Main = 'main',
	MyItems = 'myItems',
	Favorites = 'favorites',
}

export const appAdsFilterButtons = {
	[AppAdsFilter.Main]: {
		name: 'Главная',
		icon: compass,
	},
	[AppAdsFilter.Realty]: {
		name: 'Недвижимость',
		icon: house,
	},
	[AppAdsFilter.Vehicle]: {
		name: 'Транспорт',
		icon: car,
	},
	[AppAdsFilter.Clothes]: {
		name: 'Одежда',
		icon: shirt,
	},
	[AppAdsFilter.Other]: {
		name: 'Разное',
		icon: box,
	},
};
